export type Platform = 'common' | 'mobile' | 'desktop';

export const Platform = {
    Common: 'common',
    Mobile: 'mobile',
    Desktop: 'desktop',
} as const;

export const PlatformClass = {
    [Platform.Common]: 'platform-common',
    [Platform.Mobile]: 'platform-mobile',
    [Platform.Desktop]: 'platform-desktop',
} as const;

export const CSS_FILE_REGEXP = /\.s?css$/;
export const CSS_MODULE_FILE_REGEXP = /\.module\.s?css$/;
